import myGoalService from "../services/mygoal.service";
import RestService from "../services/rest.service";

export const getGoalList = (id, page) => (dispatch) => {
  return myGoalService.getGoalList(id, page).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getGoalListByEvaluate = (id) => (dispatch) => {
  return myGoalService.getGoalListByEvaluate(id).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getGoalCycle = (id) => (dispatch) => {
  return myGoalService.getGoalCycle(id).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_CYCLE",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};


export const getGroupLibrary = (id) => (dispatch) => {
  return myGoalService.getGroup("", id).then(
    (response) => {
      dispatch({
        type: "SET_GROUP_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getGoalType = (serial) => (dispatch) => {
  return myGoalService.getType(serial).then(
    (response) => {
      dispatch({
        type: "SET_GOAL_TYPE",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getGroupCategory = (serial) => (dispatch) => {
  return myGoalService.getCategory(serial).then(
    (response) => {
      dispatch({
        type: "SET_GROUP_CATEGORY",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getScaleLevel = (serial) => (dispatch) => {
  return myGoalService.getScaleLevel(serial).then(
    (response) => {
      dispatch({
        type: "SET_SCALE_LEVEL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getCustomForm = (serial) => (dispatch) => {
  return myGoalService.getCustomForm(serial).then(
    (response) => {
      dispatch({
        type: "SET_CUSTOM_FORM",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getDropdownMetric = () => (dispatch) => {
  return myGoalService.getDropdownMetric().then(
    (response) => {
      dispatch({
        type: "SET_DROPDOWN_METRIC",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getDropdownUnit = () => (dispatch) => {
  return myGoalService.getDropdownUnit().then(
    (response) => {
      dispatch({
        type: "SET_DROPDOWN_UNIT",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};

export const getCategoryWeight = (id, serial, goalSerial) => (dispatch) => {
  return myGoalService.getCategoryWeight(id, serial, goalSerial).then(
    (response) => {
      dispatch({
        type: "SET_CATEGORY_WEIGHT",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getLibraryList = (id, perPage, currentPage) => (dispatch) => {
  return myGoalService.getLibraryList(id, perPage, currentPage).then(
    (response) => {
      dispatch({
        type: "SET_LIBRARY_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getMemberTeamList = () => (dispatch) => {
  return myGoalService.getMemberTeamList().then(
    (response) => {
      dispatch({
        type: "SET_MEMBER_TEAM_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getMemberList = (serial) => (dispatch) => {
  return myGoalService.getMemberList(serial).then(
    (response) => {
      dispatch({
        type: "SET_MEMBER_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getEvaluatorList = () => (dispatch) => {
  return myGoalService.getEvaluatorList().then(
    (response) => {
      dispatch({
        type: "SET_EVALUATOR_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getAlignmentList = (cycle_id = null) => (dispatch) => {
  return myGoalService.getAlignmentList(cycle_id).then(
    (response) => {
      dispatch({
        type: "SET_ALIGNMENT_LIST",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getMyGoalDetail = (serial, opt = {}) => (dispatch) => {
  return myGoalService.getMyGoalDetail(serial, opt).then(
    (response) => {
      dispatch({
        type: "SET_MYGOAL_DETAIL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const getMyGoalProgress = (serial) => (dispatch) => {
  return myGoalService.getMyGoalProgress(serial).then(
    (response) => {
      dispatch({
        type: "SET_MYGOAL_PROGRESS",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
};
export const postCreateMyGoal = (data) => (dispatch) => {
  return myGoalService.postCreateMygoal(data).then(
    (response) => {
      dispatch({
        type: "POST_CREATE_GOAL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const putEditMyGoal = (serial, data) => (dispatch) => {
  return myGoalService.putEditMyGoal(serial, data).then(
    (response) => {
      dispatch({
        type: "PUT_EDIT_GOAL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const getMyGoalEditDetail = (serial) => (dispatch) => {
  return myGoalService.getMyGoalEditDetail(serial).then(
    (response) => {
      dispatch({
        type: "GET_MYGOAL_DETAIL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const deleteMyGoal = (serial) => (dispatch) => {
  return myGoalService.deleteMyGoal(serial).then(
    (response) => {
      dispatch({
        type: "DELETE_MYGOAL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const putDeleteMyGoal = (serial, data) => (dispatch) => {
  return myGoalService.putDeleteMyGoal(serial, data).then(
    (response) => {
      dispatch({
        type: "PUT_DELETE_MYGOAL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const getGoalForEdit = (serial) => (dispatch) => {
  return myGoalService.getGoalForEdit(serial).then(
    (response) => {
      dispatch({
        type: "GET_MYGOAL_EDIT",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const postSubmitApproval = (serial, data) => (dispatch) => {
  return myGoalService.postSubmitApproval(serial, data).then(
    (response) => {
      dispatch({
        type: "POST_SUBMIT_APPROVAL",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const putUpdateProgress = (serial, data) => (dispatch) => {
  return myGoalService.putUpdateProgress(serial, data).then(
    (response) => {
      dispatch({
        type: "UPDATE_PROGRESS",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const putUpdateProgressHistory = (serial, data) => (dispatch) => {
  return myGoalService.putUpdateProgressHistory(serial, data).then(
    (response) => {
      dispatch({
        type: "UPDATE_PROGRESS",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const deleteProgressHistory = (serial) => (dispatch) => {
  return myGoalService.deleteProgressHistory(serial).then(
    (response) => {
      dispatch({
        type: "DELETE_PROGRESS_HISTORY",
        payload: response,
      });
      return Promise.resolve(response);
    }
  );
}
export const postUploadFile = (serial, file) => (dispatch) => {
  let data = new FormData();
  for (let index = 0; index <= file.length - 1; index++) {
    data.append("file", file[index]);
  }
  return new Promise((resolve, reject) => {
    RestService.posts(`app/kpi/goals/${serial}/files`, data).then(
      (response) => {
        let resp = response.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getGoalFiles = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/goals/file/${serial}`).then(
      (response) => {
        console.log(response.data, 74155);
        let resp = response.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getConfigUpload = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/config/upload/kpi_goal_file`).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const deleteFileGoal = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.delete(`app/kpi/goals/file/${serial}`).then(
      (response) => {
        let resp = response.data
        resolve(resp)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getFileDetail = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/achievement/file/${serial}`).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getGoalChart = (serial) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/goal/chart/${serial}`).then(
      (response) => {
        resolve(response?.data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}